import { render, staticRenderFns } from "./SettingsTests.vue?vue&type=template&id=e7d6d068"
import script from "./SettingsTests.vue?vue&type=script&lang=js"
export * from "./SettingsTests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports